import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import {
  faGraduationCap,
  faUser,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";
import { faFile } from "@fortawesome/free-regular-svg-icons";
import { M1_ContractStatuses } from "../../Constants/Enums";

const ContractFormStatuses = ({ currentStep }) => {
  const [stepValue, setStepValue] = useState();

  useEffect(()=>{
    currentStep > 4 ? setStepValue(4) : setStepValue(parseInt(currentStep));
  },[currentStep])

  const getStatusDescriptionByIndex = (step, isNextElement = false) => {
    let stepHelper = step;
    !isNextElement && step === 4 && (stepHelper = currentStep);
    
    for (const key in M1_ContractStatuses) {
        if (M1_ContractStatuses[key].value === stepHelper) {
            return M1_ContractStatuses[key].description;
        }
    }
    return null;
};

  const renderMobileView = () => {
    return (
      
     !!stepValue && (<Row className="mx-5 mt-2 mb-2">
        <Col xs={"auto"} className="text-center d-flex">
          {stepValue - 1 === 0 ? (
            <FontAwesomeIcon
              icon={faCheck}
              className="progress-point-icon progress-point-side-icon"
            />
          ) : (
            <FontAwesomeIcon
              icon={faFile}
              className="progress-point-icon progress-point-side-icon"
            />
          )}
          <div className="progress-point-main-text d-inline-block prev-next-statuses">
            {getStatusDescriptionByIndex(stepValue - 1)}
          </div>
        </Col>
        <Col>
          <hr className="progress-point-hr" />
        </Col>
        <Col xs={"auto"} className="text-center d-flex">
          <FontAwesomeIcon icon={faFile} className="progress-point-icon" />
          <div className="progress-point-main-text d-inline-block">
            {getStatusDescriptionByIndex(stepValue)}
          </div>
        </Col>
        <Col>
          <hr className="progress-point-hr" />
        </Col>
        <Col xs={"auto"} className="text-center d-flex">
          {stepValue > 3 ? (
            <FontAwesomeIcon
              icon={faCheck}
              className="progress-point-icon progress-point-side-icon"
            />
          ) : (
            <>
            <FontAwesomeIcon
              icon={faFile}
              className="progress-point-icon progress-point-side-icon"
            />
            <div className="progress-point-main-text d-inline-block prev-next-statuses">
            {getStatusDescriptionByIndex(stepValue + 1, true)}
            </div>
            </>
          )}
        </Col>
      </Row>)
    );
  };

  return <>{renderMobileView()}</>;
};

export default ContractFormStatuses;
